import React from 'react';
import styled from 'styled-components';
import useConfig from '@empiriecom/module-components/hooks/useConfig';
import { FragmentConfiguration } from '@/config';

interface RatingStarsProps {
  maskWidth: string;
  // eslint-disable-next-line react/require-default-props
  className?: string;
}

const RatingStars = (props: RatingStarsProps): JSX.Element => {
  const { maskWidth, className } = props;
  const config: FragmentConfiguration = useConfig();
  return config.customerRatings.iconType === 'SHOE' ? (
    // allow prop spreading for svg icon
    // eslint-disable-next-line react/jsx-props-no-spreading
    <svg viewBox="0 0 160 32" className={className}>
      <defs>
        <polygon
          id="shoe"
          points="1.0920000000 27.1280000000, 1.6740000000 25.7560000000, 8.0900000000 21.7680000000, 10.1260000000 20.2290000000, 13.5880000000 19.9280000000, 15.0790000000 18.3950000000, 19.1590000000 12.2590000000, 22.0760000000 7.3510000000, 25.8660000000 3.8420000000, 27.3200000000 2.1340000000, 30.2380000000 5.8150000000, 30.8200000000 10.1040000000, 29.9470000000 12.8700000000, 29.6480000000 17.7730000000, 29.0660000000 24.8380000000, 27.3210000000 24.8380000000, 27.3210000000 14.7180000000, 26.4490000000 14.7180000000, 24.4060000000 17.1680000000, 22.0770000000 23.6100000000, 18.8710000000 26.9850000000, 12.4620000000 27.4420000000, 1.6760000000 27.4420000000, 1.0940000000 27.1290000000"
        />
        <clipPath id="shoes">
          <use href="#shoe" xlinkHref="#shoe" />
          <use href="#shoe" xlinkHref="#shoe" x="20%" />
          <use href="#shoe" xlinkHref="#shoe" x="40%" />
          <use href="#shoe" xlinkHref="#shoe" x="60%" />
          <use href="#shoe" xlinkHref="#shoe" x="80%" />
        </clipPath>
      </defs>
      <rect
        width="100%"
        height="100%"
        className="rating__background"
        clipPath="url(#shoes)"
        fill={config.customerRatings.iconColor}
      />
      <rect
        width={maskWidth}
        height="100%"
        className="rating__value"
        clipPath="url(#shoes)"
        fill={config.customerRatings.iconColor}
      />
    </svg>
  ) : (
    // allow prop spreading for svg icon
    // eslint-disable-next-line react/jsx-props-no-spreading
    <svg viewBox="0 0 180 36" className={className}>
      <defs>
        <polygon
          id="star"
          points="18.0000000000 28.3190000000, 7.2230000000 34.8750000000, 10.0200000000 22.4200000000, 0.5620000000 14.0170000000, 13.0680000000 12.8750000000, 18.0000000000 1.1260000000, 22.9320000000 12.8750000000, 35.4380000000 14.0170000000, 25.9800000000 22.4200000000, 28.7770000000 34.8750000000"
        />
        <clipPath id="stars">
          <use href="#star" xlinkHref="#star" />
          <use href="#star" xlinkHref="#star" x="20%" />
          <use href="#star" xlinkHref="#star" x="40%" />
          <use href="#star" xlinkHref="#star" x="60%" />
          <use href="#star" xlinkHref="#star" x="80%" />
        </clipPath>
      </defs>
      <rect
        width="100%"
        height="100%"
        className="rating__background"
        clipPath="url(#stars)"
        fill={config.customerRatings.iconColor}
      />
      <rect
        width={maskWidth}
        height="100%"
        className="rating__value"
        clipPath="url(#stars)"
        fill={config.customerRatings.iconColor}
      />
    </svg>
  );
};

const StyledRatingIcons = styled(RatingStars)<{ iconType: string }>`
  vertical-align: middle;
  #star {
    width: auto;
    height: 100%;
  }
  .rating__background {
    fill: ${({ iconType }) => (iconType === 'SHOE' ? '#c4b89e' : '#eeeeee')};
    color: ${({ iconType }) => (iconType === 'SHOE' ? '#c4b89e' : '#eeeeee')};
    height: 100%;
    width: 100%;
  }
  .rating__value {
    height: 100%;
  }
`;

export default StyledRatingIcons;
